<div mat-dialog-content>
    <h2 class="verify-title">Verify phone number</h2>

    <h3>1-time token has been sent via SMS to phone number ***{{phone | slice:-3}}</h3>

    <form [formGroup]="formGroup">
        <mat-form-field class="mfa-code">
            <input matInput type="tel" formControlName="code" placeholder="Enter Code" ngcAutofocus>
        </mat-form-field>
    </form>
    <button mat-button color="primary"
            class="submit-button"
            aria-label="Resend code"
            title="Resend code"
            (click)="onSendCodeAgain()"
            [disabled]="!!disableResendCodeBtnTimer || isSpinnerActive"
    >
        Resend code {{disableResendCodeBtnTimer ? '(' + disableResendCodeBtnTimer + ')' : '' }}
    </button>
</div>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <div class="action-buttons-block">
        <button mat-button
                type="button"
                (click)="doCancel()"
                class="mr-8"
                tabindex="12"
        >
            Cancel
        </button>
        <button mat-raised-button
                color="primary"
                (click)="onVerifyCode()"
                [disabled]="formGroup?.invalid || isSpinnerActive"
        >
            Verify
        </button>
    </div>
</mat-dialog-actions>
